import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { change } from 'redux-form'
import { get } from 'lodash'
import { getBrandClassName } from '../../reducers/packageDetails'
import { updateAlternateDateSelection } from '../../actions/forms'
import { updateCurrentAppStep } from '../../actions/appState'
import LoadingIcon from '../../assets/icons/brand-loader-final.gif'
import EQuotePackageRelatedSailingsSlider from './EQuotePackageRelatedSailingsSlider'
import '../../styles/scss/components/equote-package-related-sailings.scss'
import { setActivePackage } from '../../actions/activePackage'
import { getRelatedSailings } from '../../reducers/availablePackages'
import { getSingleBrandDetails } from '../../reducers/brands'
import { getDestinationDetails } from '../../reducers/destinations'
import EQuotePackageRelatedSailingsTable from './EQuotePackageDetailsRelatedSailingsTable'
import { getIsActivePackageBundled } from '../../reducers/activePackage'

const goToNextPage = (packageData, requestAlternateSailing) => {
  window.scrollTo(0, 0) //Scroll Page every time the function updateCurrentStep is called
  requestAlternateSailing(packageData.sailDate, packageData.identifier)
}

const EQuotePackageRelatedSailings = props => {
  //delete content from last th for accessibility
  useEffect(() => {
    const lastHeaderColumn = document.querySelector(
      '.equote-package-related-sailings-table-container th:last-of-type'
    )
    lastHeaderColumn &&
      lastHeaderColumn.firstChild &&
      lastHeaderColumn.removeChild(lastHeaderColumn.firstChild)
  })

  if (
    !props.isLoading &&
    (!props.availableStateRooms || !props.sailings || !props.sailings.length)
  )
    return null

  return (
    <div
      id="similar-sailings"
      className="equote-package-related-sailings-container"
    >
      <h1 className={`section-title ${props.brandClassName} u-text-center`}>
        Other Departure Dates
      </h1>
      {props.isLoading ? (
        <div className="u-loading-spinner">
          <img src={LoadingIcon} alt="loading related sailings" />
        </div>
      ) : (
        <>
          {Boolean(props.sailings.length) ? (
            <>
              <div className="equote-package-related-sailings-table">
                <div className="equote-package-related-sailings-table-container">
                  <EQuotePackageRelatedSailingsTable
                    {...props}
                    goToNextPage={goToNextPage}
                  />
                </div>
              </div>
              <EQuotePackageRelatedSailingsSlider
                goToNextPage={goToNextPage}
                {...props}
              />
            </>
          ) : (
            <div className="similar-sailings--no-results-text">
              <p>No related sailings</p>
            </div>
          )}
        </>
      )}
    </div>
  )
}

const mapStateToProps = state => {
  const relatedSailings = getRelatedSailings(state)
  const brandData = getSingleBrandDetails(state)
  const currency = state.activeSearchParameters.currency || 'USD'
  const isBundlePricing = getIsActivePackageBundled(state)
  let disclaimer = brandData ? brandData.disclaimer_pricing : null

  if (disclaimer && currency && currency !== 'USD') {
    disclaimer = disclaimer.replace(/USD/gi, currency)
  }

  if (isBundlePricing && disclaimer) {
    disclaimer = disclaimer.replace(
      'expenses are additional',
      'expenses are included'
    )
  }

  const sailings = relatedSailings
    ? relatedSailings.sort((a, b) =>
        moment(a.sailDate, 'YYYY-MM-DD').isBefore(
          moment(b.sailDate, 'YYYY-MM-DD')
        )
          ? -1
          : 1
      )
    : []

  const brandClassName = getBrandClassName(state)
  const brandCode = get(brandData, 'brand_code', '').toLowerCase()

  const destinationDetails = getDestinationDetails(state)
  const brandDestinationImage = brandCode
    ? get(destinationDetails, [
        `image_${brandCode}`,
        0,
        'sizes',
        'user-agreement',
        'src'
      ])
    : get(destinationDetails, [
        'relatedSailing_image',
        0,
        'sizes',
        'user-agreement',
        'src'
      ])

  return {
    sailings,
    disclaimer,
    brandClassName,
    availableStateRooms: state.shipStateRooms.availableRooms,
    isLoading:
      state.relatedSailings.isLoading || state.shipStateRooms.isLoading,
    occupancy:
      state.activeSearchParameters && state.activeSearchParameters.occupancy
        ? state.activeSearchParameters.occupancy
        : 1,
    brandDestinationImage
  }
}

const mapDispatchToProps = dispatch => ({
  requestAlternateSailing(sailDate, identifier) {
    dispatch(updateAlternateDateSelection(sailDate))
    dispatch(
      change('EQuotePackageAdditionalDetailsForm', 'Date', moment(sailDate))
    )
    dispatch(setActivePackage(identifier))
    dispatch(updateCurrentAppStep(1))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EQuotePackageRelatedSailings)
